// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"92617be4","43":"c8e4a248","375":"0ede2e39","631":"34ed298b","950":"e9480162"}[chunkId] + ".chunk.js";
};